module.exports = __webpack_public_path__ + "img/111.ee3a04fe.png";